import { useState } from "react";
import { motion } from "framer-motion";
import {
  FaGithub,
  FaLinkedin,
  FaFacebook,
  FaWhatsapp,
  FaRegCopy,
  FaCheck,
  FaEnvelope,
} from "react-icons/fa";

import { personalInfo } from "../lib/ui";

const socialLinks = [
  {
    icon: FaGithub,
    label: "GitHub",
    link: personalInfo.github,
    bg: "bg-slate-800",
    text: "text-white",
  },
  {
    icon: FaLinkedin,
    label: "LinkedIn",
    link: personalInfo.linkedin,
    bg: "bg-[#0077b5]",
    text: "text-white",
  },
  {
    icon: FaFacebook,
    label: "Facebook",
    link: personalInfo.facebook,
    bg: "bg-[#1877f2]",
    text: "text-white",
  },
  {
    icon: FaWhatsapp,
    label: "WhatsApp",
    link: personalInfo.whatsapp,
    bg: "bg-[#25D366]",
    text: "text-white",
  },
];

export default function SocialButtons() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(personalInfo.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-col gap-4 w-full max-w-md mx-auto lg:mx-0 lg:ml-auto">
      {/* Primary Action: Email Copy Block */}
      <motion.div
        className="group relative bg-app-panel rounded-3xl p-2 pl-6 shadow-soft border border-app-border flex items-center justify-between transition-all duration-300 hover:shadow-glow hover:border-app-accent/50"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center gap-4 min-w-0">
          <div className="shrink-0 w-10 h-10 rounded-full bg-app-accent/10 text-app-accent flex items-center justify-center">
            <FaEnvelope size={16} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-wider text-app-mute mb-0.5">
              Email Address
            </p>
            <p className="text-sm sm:text-base font-semibold text-app-text font-mono truncate">
              {personalInfo.email}
            </p>
          </div>
        </div>

        <button
          onClick={handleCopyEmail}
          className={`shrink-0 flex items-center justify-center w-12 h-12 rounded-2xl transition-all duration-300 ${
            copied
              ? "bg-app-accent text-white shadow-glow"
              : "bg-app-soft text-app-mute hover:bg-app-accent/10 hover:text-app-accent"
          }`}
          aria-label="Copy email address"
        >
          {copied ? <FaCheck size={16} /> : <FaRegCopy size={16} />}
        </button>
      </motion.div>

      {/* Secondary Actions: Social Links Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {socialLinks.map((social, index) => (
          <motion.a
            key={social.label}
            href={social.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex flex-col items-center justify-center gap-2 p-4 rounded-3xl bg-app-panel border border-app-border shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-glow-v group`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 + index * 0.05 }}
          >
            <div className={`w-10 h-10 rounded-2xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110 ${social.bg} ${social.text}`}>
              <social.icon size={18} />
            </div>
            <span className="text-[10px] font-bold text-app-mute uppercase tracking-wide group-hover:text-app-text transition-colors">
              {social.label}
            </span>
          </motion.a>
        ))}
      </div>
    </div>
  );
}
